import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const userSingleCourseTopicsTableHeadings = [
	{ data: 'order', title: ls('Order') },
	{
		data: 'topicName',
		title: sprintf(reportingApiSetup.localizedStrings.tablesColumnsTopicName, reportingApiSetup.learnDashLabels.topic)
	},
	{ data: 'status', title: ls('Status') },
	{ data: 'associatedLesson', title: ls('Associated Lesson') },
	{ data: 'completedDate', title: ls('Completion Date') }
];

const userSingleCourseTopicsTableData = function(courseID) {
	var tableData = [];
	return tableData;
};

export {
	userSingleCourseTopicsTableHeadings,
	userSingleCourseTopicsTableData
};
